import React from "react"
import PropTypes from "prop-types"
import AsyncSelect from 'react-select/async';

class SelectLocation extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      account: props.account,
      locations: props.locations,
      default_locations: props.default_locations,
      element_id: props.element_id,
      multiple: props.multiple,
      isLoading: true,
    };
  }

  componentDidMount() {
  }

  renderSelectLocation() {
    let debounceTimer;
    const account = this.state.account;
    const locations = this.state.locations;
    const default_locations = this.state.default_locations;
    const element_id = this.state.element_id;
    const multiple = this.state.multiple;

    const handleInputChange = value => {
    };

    const handleChange = value => {
      this.setState({
        locations: value,
      });
      if (multiple) {
        let result = value.map((tag) => tag.id);
        document.getElementById(element_id).value = JSON.stringify(result);
      } else {
        document.getElementById(element_id).value = value ? value.id : null;
      }
    };

    const loadOptions = (value) => {
      return fetch(`/accounts/${account.id}/locations/select?search=${value}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          }
        }
      )
      .then(response => response.json());
    };

    const promiseOptions = (value) =>
      new Promise((resolve) => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          resolve(loadOptions(value));
        }, 1000);
      });

    const handleFocus = () => {
      if (!locations && (!default_locations || default_locations.length === 0)) {
        loadOptions("").then((options) => {
          this.setState({ default_locations: options });
        });
      }
    };

    const customOption = (location) => {
      return (
        <div>
          <div className="d-flex align-items-center">
            <div className="mr-1">
              {location["title"]}
            </div>
            {location["badge"] && <div className="ml-auto small">
              {location["badge"]}
            </div>}
          </div>
          {location["description"] && <div className="small select-description">
            {location["description"]}
          </div>}
        </div>
      );
    }

    return (
      <AsyncSelect
        cacheOptions
        defaultOptions={default_locations}
        isMulti={multiple}
        placeholder={this.props.placeholder || "Select a location..."}
        value={locations}
        getOptionLabel={c => customOption(c)}
        getOptionValue={c => c.id}
        loadOptions={promiseOptions}
        onInputChange={handleInputChange}
        onChange={handleChange}
        onFocus={handleFocus}
        isClearable
        styles={{
          singleValue: (base) => ({ ...base, width: '96%' }),
          valueContainer: (base) => ({ ...base, minHeight: '44px'}),
        }}
      />
    );
  }

  render () {
    return (
      <div>
        {this.renderSelectLocation()}
      </div>
    );
  }
}

SelectLocation.propTypes = {
  account: PropTypes.object,
  locations: PropTypes.object,
  default_locations: PropTypes.array,
  element_id: PropTypes.string,
  multiple: PropTypes.bool,
  placeholder: PropTypes.string,
};
export default SelectLocation;
